import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useTenant } from "@/context/TenantContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

// Autorizzazione lato pagina per modulo: la rotta è raggiungibile solo se il
// modulo risulta attivo nelle effective capabilities del backend
// (GET /auth/capabilities → modules). Il fallback è una pagina chiara, non un
// errore tecnico. I controlli server-side sugli endpoint restano obbligatori.
export default function ModuleRoute({ module, children }) {
  const { caps } = useTenant();
  const navigate = useNavigate();
  if (!caps) {
    return <p className="text-sm text-slate-500" data-testid="module-route-loading">Caricamento…</p>;
  }
  if (module && !(caps.modules || {})[module]) {
    return (
      <div className="max-w-lg mx-auto mt-16" data-testid="module-disabled-page">
        <Card className="border-amber-200 bg-amber-50">
          <CardContent className="p-8 text-center space-y-3">
            <ShieldAlert className="w-9 h-9 text-amber-600 mx-auto" aria-hidden="true" />
            <p className="text-base font-bold text-slate-900">Modulo non attivo</p>
            <p className="text-sm text-slate-600">
              Il modulo <strong>{module}</strong> non è attivo per questa azienda.
              Contatta il consulente o l'amministratore della piattaforma per attivarlo.
            </p>
            <Button variant="outline" className="mt-2" onClick={() => navigate("/dashboard")}
              data-testid="module-disabled-back">
              Torna alla dashboard
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }
  return children;
}
